import { render, staticRenderFns } from "./album.vue?vue&type=template&id=43d22d7f&"
import script from "./album.vue?vue&type=script&lang=ts&"
export * from "./album.vue?vue&type=script&lang=ts&"
import style0 from "./album.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports